import { render } from "./AppHeaderPublic.vue?vue&type=template&id=344bfded&scoped=true"
import script from "./AppHeaderPublic.vue?vue&type=script&lang=js"
export * from "./AppHeaderPublic.vue?vue&type=script&lang=js"

import "./AppHeaderPublic.vue?vue&type=style&index=0&id=344bfded&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-344bfded"

export default script